export const getSubLabel = (label: string): string => {
	if (!label) return label
	const splittedLabel = label.split('(')
	if (splittedLabel.length <= 1) return label
	return splittedLabel[1].replace(')', '')
}
